import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, HostBinding, NgModule, ViewChild, Injectable, inject, isDevMode } from '@angular/core';
import * as i2 from '@spartacus/checkout/base/components';
import { CheckoutAuthGuard, CartNotEmptyGuard, CheckoutDeliveryAddressComponent, CheckoutReviewSubmitComponent, CheckoutStepsSetGuard } from '@spartacus/checkout/base/components';
import { CartValidationGuard } from '@spartacus/cart/base/core';
import * as i1 from '@spartacus/core';
import { I18nModule, ConfigModule, FeaturesConfigModule, provideDefaultConfig, GlobalMessageType, isNotUndefined, getLastValueSync, UrlModule, B2BUserRole, LoggerService } from '@spartacus/core';
import { Subscription, combineLatest, of, BehaviorSubject } from 'rxjs';
import { filter, distinctUntilChanged, map, take, tap, switchMap, catchError } from 'rxjs/operators';
import * as i5 from '@spartacus/checkout/b2b/root';
import { B2BPaymentTypeEnum } from '@spartacus/checkout/b2b/root';
import * as i3 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i7 from '@spartacus/storefront';
import { CardModule, SpinnerModule, PromotionsModule, IconModule, OutletModule } from '@spartacus/storefront';
import * as i8 from '@spartacus/user/profile/components';
import { AddressFormModule } from '@spartacus/user/profile/components';
import * as i1$1 from '@spartacus/checkout/base/root';
import * as i4 from '@spartacus/cart/base/root';
import * as i5$1 from '@spartacus/user/account/root';

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
function CheckoutCostCenterComponent_ng_container_0_ng_container_3_div_1_option_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const costCenter_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("value", costCenter_r3.code);
    i0.ɵɵproperty("selected", ctx_r1.costCenterId === costCenter_r3.code);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", costCenter_r3.name, " ");
  }
}
function CheckoutCostCenterComponent_ng_container_0_ng_container_3_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "label")(2, "span", 3);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "select", 4);
    i0.ɵɵlistener("change", function CheckoutCostCenterComponent_ng_container_0_ng_container_3_div_1_Template_select_change_5_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.setCostCenter($event.target.value));
    });
    i0.ɵɵtemplate(6, CheckoutCostCenterComponent_ng_container_0_ng_container_3_div_1_option_6_Template, 2, 3, "option", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "span", 6);
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const costCenters_r4 = i0.ɵɵnextContext().ngIf;
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 3, "checkoutB2B.costCenter"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", costCenters_r4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(9, 5, "checkoutB2B.availableLabel"));
  }
}
function CheckoutCostCenterComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutCostCenterComponent_ng_container_0_ng_container_3_div_1_Template, 10, 7, "div", 0);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const costCenters_r4 = ctx.ngIf;
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", costCenters_r4.length !== 0);
  }
}
function CheckoutCostCenterComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 1)(2, "div", 2);
    i0.ɵɵtemplate(3, CheckoutCostCenterComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 0);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 1, ctx_r1.costCenters$));
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 9);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 18)(2, "button", 19);
    i0.ɵɵlistener("click", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_3_Template_button_click_2_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.showNewAddressForm());
    });
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 1, "checkoutAddress.addNewAddress"), " ");
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵlistener("click", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_5_Template_div_click_1_listener() {
      const card_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.selectAddress(card_r5.address));
    });
    i0.ɵɵelementStart(2, "cx-card", 22);
    i0.ɵɵlistener("sendCard", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_5_Template_cx_card_sendCard_2_listener() {
      const card_r5 = i0.ɵɵrestoreView(_r4).$implicit;
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.selectAddress(card_r5.address));
    });
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const card_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("border", true)("index", i_r6)("fitToContainer", true)("content", card_r5.card)("role", "group");
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p", 10);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_3_Template, 5, 3, "div", 11);
    i0.ɵɵelementStart(4, "div", 12);
    i0.ɵɵtemplate(5, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_div_5_Template, 3, 5, "div", 13);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 14)(7, "div", 15)(8, "button", 16);
    i0.ɵɵlistener("click", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_Template_button_click_8_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.back());
    });
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 15)(12, "button", 17);
    i0.ɵɵpipe(13, "async");
    i0.ɵɵlistener("click", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_Template_button_click_12_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r2 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r2.next());
    });
    i0.ɵɵtext(14);
    i0.ɵɵpipe(15, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_11_0;
    const cards_r7 = i0.ɵɵnextContext(2).ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 6, "checkoutAddress.selectYourDeliveryAddress"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isAccountPayment);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", cards_r7);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(10, 8, ctx_r2.backBtnText), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("disabled", !((tmp_11_0 = i0.ɵɵpipeBind1(13, 10, ctx_r2.selectedAddress$)) == null ? null : tmp_11_0.id));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(15, 12, "common.continue"), " ");
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-address-form", 24);
    i0.ɵɵlistener("backToAddress", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template_cx_address_form_backToAddress_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.hideNewAddressForm(false));
    })("submitAddress", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template_cx_address_form_submitAddress_0_listener($event) {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.addAddress($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵproperty("showTitleCode", true);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cx-address-form", 25);
    i0.ɵɵpipe(1, "cxTranslate");
    i0.ɵɵlistener("backToAddress", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template_cx_address_form_backToAddress_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.hideNewAddressForm(true));
    })("submitAddress", function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template_cx_address_form_submitAddress_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r2.addAddress($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate("cancelBtnLabel", i0.ɵɵpipeBind1(1, 3, ctx_r2.backBtnText));
    i0.ɵɵproperty("showTitleCode", true)("setAsDefaultField", !ctx_r2.isGuestCheckout);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_cx_address_form_0_Template, 1, 1, "cx-address-form", 23)(1, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_ng_template_1_Template, 2, 5, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor);
  }
  if (rf & 2) {
    const initialAddressForm_r10 = i0.ɵɵreference(2);
    const cards_r7 = i0.ɵɵnextContext(2).ngIf;
    i0.ɵɵproperty("ngIf", cards_r7.length)("ngIfElse", initialAddressForm_r10);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_div_1_Template, 2, 3, "div", 7)(2, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_container_2_Template, 1, 0, "ng-container", 8)(3, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_3_Template, 16, 14, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(5, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_ng_template_5_Template, 3, 2, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const showExistingAddresses_r11 = i0.ɵɵreference(4);
    const newAddressForm_r12 = i0.ɵɵreference(6);
    const cards_r7 = i0.ɵɵnextContext().ngIf;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isAccountPayment || (cards_r7 == null ? null : cards_r7.length) && !ctx_r2.addressFormOpened)("ngIfThen", showExistingAddresses_r11)("ngIfElse", newAddressForm_r12);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutDeliveryAddressComponent_ng_container_3_ng_container_1_Template, 7, 4, "ng-container", 6);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const loading_r13 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !i0.ɵɵpipeBind1(2, 2, ctx_r2.isUpdating$))("ngIfElse", loading_r13);
  }
}
function B2BCheckoutDeliveryAddressComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
const _c0 = ["poNumber"];
function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_div_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 15);
    i0.ɵɵpipe(1, "cxTranslate");
  }
  if (rf & 2) {
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 1, "common.loaded"));
  }
}
function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_div_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 16)(1, "input", 17);
    i0.ɵɵlistener("change", function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_div_18_Template_input_change_1_listener() {
      const type_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r3 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r3.changeType(type_r3.code));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "label", 18)(3, "div", 19);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "cxTranslate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const type_r3 = ctx.$implicit;
    const ctx_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "paymentType-", type_r3.code, "");
    i0.ɵɵproperty("value", type_r3.code)("checked", type_r3.code === ctx_r3.typeSelected);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("for", "paymentType-", type_r3.code, "");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 7, "paymentTypes.paymentType_" + (type_r3 == null ? null : type_r3.code)), " ");
  }
}
function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_div_1_Template, 2, 3, "div", 5);
    i0.ɵɵelementStart(2, "div", 6)(3, "div", 7)(4, "label")(5, "span", 8);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(8, "input", 9, 1);
    i0.ɵɵpipe(10, "cxTranslate");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "div", 6)(13, "div", 7)(14, "label", 10)(15, "span", 8);
    i0.ɵɵtext(16);
    i0.ɵɵpipe(17, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(18, CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_div_18_Template, 6, 9, "div", 11);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(19, "div", 12)(20, "div", 7)(21, "button", 13);
    i0.ɵɵlistener("click", function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_Template_button_click_21_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.back());
    });
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "cxTranslate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 7)(25, "button", 14);
    i0.ɵɵlistener("click", function CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_Template_button_click_25_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r3 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r3.next());
    });
    i0.ɵɵtext(26);
    i0.ɵɵpipe(27, "cxTranslate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const paymentTypes_r5 = i0.ɵɵnextContext().ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxFeature", "!a11yRemoveStatusLoadedRole");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 8, "checkoutB2B.poNumber"));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(10, 10, "checkoutB2B.placeholder"));
    i0.ɵɵpropertyInterpolate("value", i0.ɵɵpipeBind1(11, 12, ctx_r3.cartPoNumber$));
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(17, 14, "paymentTypes.title"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", paymentTypes_r5);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 16, "checkout.backToCart"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(27, 18, "common.continue"), " ");
  }
}
function CheckoutPaymentTypeComponent_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, CheckoutPaymentTypeComponent_ng_container_3_ng_container_1_Template, 28, 20, "ng-container", 4);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const paymentTypes_r5 = ctx.ngIf;
    const ctx_r3 = i0.ɵɵnextContext();
    const loading_r6 = i0.ɵɵreference(6);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !!paymentTypes_r5.length && i0.ɵɵpipeBind1(2, 2, ctx_r3.typeSelected$) && !i0.ɵɵpipeBind1(3, 4, ctx_r3.isUpdating$))("ngIfElse", loading_r6);
  }
}
function CheckoutPaymentTypeComponent_ng_template_5_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 21);
    i0.ɵɵelement(1, "cx-spinner");
    i0.ɵɵelementEnd();
  }
}
function CheckoutPaymentTypeComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CheckoutPaymentTypeComponent_ng_template_5_div_0_Template, 2, 0, "div", 20);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r3.paymentTypesError);
  }
}
const _c1 = a0 => ({
  cxRoute: a0
});
const _c2 = a0 => ({
  item: a0,
  readonly: true
});
const _c3 = a0 => ({
  count: a0
});
const _c4 = () => [];
const _c5 = (a0, a1) => ({
  items: a0,
  readonly: true,
  promotionLocation: a1
});
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const poNumber_r1 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", poNumber_r1);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const paymentType_r2 = i0.ɵɵreference(10);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentType_r2);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_4_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const paymentMethod_r3 = i0.ɵɵreference(18);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", paymentMethod_r3);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_5_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_5_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const costCenter_r4 = i0.ɵɵreference(12);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", costCenter_r4);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 13);
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_2_Template, 2, 1, "ng-container", 14)(3, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_3_Template, 2, 1, "ng-container", 14)(4, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_4_Template, 2, 1, "ng-container", 14)(5, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_ng_container_5_Template, 2, 1, "ng-container", 14);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const step_r5 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", step_r5.type[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypePaymentType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypePaymentType);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypePaymentDetails);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypeDeliveryAddress);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const deliveryAddress_r7 = i0.ɵɵreference(14);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", deliveryAddress_r7);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 15);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(3);
    const deliveryMode_r8 = i0.ɵɵreference(16);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", deliveryMode_r8);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0)(1, 13);
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_2_Template, 2, 1, "ng-container", 14)(3, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_ng_container_3_Template, 2, 1, "ng-container", 14);
    i0.ɵɵelementContainerEnd()();
  }
  if (rf & 2) {
    const step_r9 = ctx.$implicit;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitch", step_r9.type[0]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypeDeliveryAddress);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngSwitchCase", ctx_r5.checkoutStepTypeDeliveryMode);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 10);
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_2_Template, 6, 5, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 12);
    i0.ɵɵtemplate(4, B2BCheckoutReviewSubmitComponent_ng_container_5_ng_container_4_Template, 4, 3, "ng-container", 11);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const steps_r10 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.paymentSteps(steps_r10));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r5.deliverySteps(steps_r10));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵelement(1, "cx-card", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 18)(5, "a", 19);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelement(8, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(3, 6, ctx_r5.getPoNumberCard(i0.ɵɵpipeBind1(2, 4, ctx_r5.poNumber$))));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 8, i0.ɵɵpureFunction1(12, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypePaymentType))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(7, 10, "checkoutReview.editPaymentType"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_9_cx_card_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 17);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const paymentType_r11 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r5.getPaymentTypeCard(paymentType_r11)));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16);
    i0.ɵɵtemplate(1, B2BCheckoutReviewSubmitComponent_ng_template_9_cx_card_1_Template, 2, 3, "cx-card", 21);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 18)(4, "a", 19);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(2, 4, ctx_r5.paymentType$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(10, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypePaymentType))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(6, 8, "checkoutReview.editPaymentType"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_11_ng_container_0_cx_card_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 17);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const costCenter_r12 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r5.getCostCenterCard(costCenter_r12)));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_11_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 16);
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_template_11_ng_container_0_cx_card_2_Template, 2, 3, "cx-card", 21);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementStart(4, "div", 18)(5, "a", 19);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelement(8, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r5.costCenter$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 6, i0.ɵɵpureFunction1(10, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypeDeliveryAddress))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(7, 8, "checkoutReview.editDeliveryAddressDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, B2BCheckoutReviewSubmitComponent_ng_template_11_ng_container_0_Template, 9, 12, "ng-container", 9);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r5.isAccountPayment$));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_13_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "cx-card", 17);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementStart(3, "div", 18)(4, "a", 19);
    i0.ɵɵpipe(5, "cxUrl");
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelement(7, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const deliveryAddress_r13 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(2, 4, ctx_r5.getDeliveryAddressCard(deliveryAddress_r13)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(5, 6, i0.ɵɵpureFunction1(10, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypeDeliveryAddress))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(6, 8, "checkoutReview.editDeliveryAddressDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, B2BCheckoutReviewSubmitComponent_ng_template_13_div_0_Template, 8, 12, "div", 22);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(1, 1, ctx_r5.deliveryAddress$));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_15_cx_card_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 17);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const deliveryMode_r14 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r5.getDeliveryModeCard(deliveryMode_r14)));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_15_ng_template_4_Template(rf, ctx) {}
function B2BCheckoutReviewSubmitComponent_ng_template_15_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div");
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_template_15_cx_card_2_Template, 2, 3, "cx-card", 21);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵtemplate(4, B2BCheckoutReviewSubmitComponent_ng_template_15_ng_template_4_Template, 0, 0, "ng-template", 25);
    i0.ɵɵpipe(5, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 18)(7, "a", 19);
    i0.ɵɵpipe(8, "cxUrl");
    i0.ɵɵpipe(9, "cxTranslate");
    i0.ɵɵelement(10, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 6, ctx_r5.deliveryMode$));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("cxOutlet", ctx_r5.cartOutlets.DELIVERY_MODE)("cxOutletContext", i0.ɵɵpureFunction1(14, _c2, i0.ɵɵpipeBind1(5, 8, ctx_r5.cart$)));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(8, 10, i0.ɵɵpureFunction1(16, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypeDeliveryMode))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(9, 12, "checkoutReview.editDeliveryMode"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_17_cx_card_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cx-card", 17);
    i0.ɵɵpipe(1, "async");
  }
  if (rf & 2) {
    const paymentDetails_r15 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("content", i0.ɵɵpipeBind1(1, 1, ctx_r5.getPaymentMethodCard(paymentDetails_r15)));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_template_17_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 26)(1, "div");
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_template_17_cx_card_2_Template, 2, 3, "cx-card", 21);
    i0.ɵɵpipe(3, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 18)(5, "a", 19);
    i0.ɵɵpipe(6, "cxUrl");
    i0.ɵɵpipe(7, "cxTranslate");
    i0.ɵɵelement(8, "cx-icon", 20);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 4, ctx_r5.paymentDetails$));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("routerLink", i0.ɵɵpipeBind1(6, 6, i0.ɵɵpureFunction1(10, _c1, ctx_r5.getCheckoutStepUrl(ctx_r5.checkoutStepTypePaymentDetails))));
    i0.ɵɵattribute("title", i0.ɵɵpipeBind1(7, 8, "checkoutReview.editPaymentDetails"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("type", ctx_r5.iconTypes.PENCIL);
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_19_div_7_ng_template_2_Template(rf, ctx) {}
function B2BCheckoutReviewSubmitComponent_ng_container_19_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 30);
    i0.ɵɵelement(1, "cx-promotions", 31);
    i0.ɵɵtemplate(2, B2BCheckoutReviewSubmitComponent_ng_container_19_div_7_ng_template_2_Template, 0, 0, "ng-template", 25);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entries_r16 = ctx.ngIf;
    const cart_r17 = i0.ɵɵnextContext().ngIf;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("promotions", (cart_r17.appliedOrderPromotions || i0.ɵɵpureFunction0(3, _c4)).concat(cart_r17.potentialOrderPromotions || i0.ɵɵpureFunction0(4, _c4)));
    i0.ɵɵadvance();
    i0.ɵɵproperty("cxOutlet", ctx_r5.cartOutlets.CART_ITEM_LIST)("cxOutletContext", i0.ɵɵpureFunction2(5, _c5, entries_r16, ctx_r5.promotionLocation));
  }
}
function B2BCheckoutReviewSubmitComponent_ng_container_19_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 27);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 28);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "cxTranslate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, B2BCheckoutReviewSubmitComponent_ng_container_19_div_7_Template, 3, 8, "div", 29);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const cart_r17 = ctx.ngIf;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind2(3, 4, "cartItems.cartTotal", i0.ɵɵpureFunction1(11, _c3, cart_r17.deliveryItemsQuantity)), ": ", cart_r17.totalPrice == null ? null : cart_r17.totalPrice.formattedValue, " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 7, "checkoutReview.placeOrder"), " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(8, 9, ctx_r5.entries$));
  }
}
let CheckoutCostCenterComponent = /*#__PURE__*/(() => {
  class CheckoutCostCenterComponent {
    get disabled() {
      return !this.isAccountPayment;
    }
    constructor(userCostCenterService, checkoutCostCenterFacade, checkoutPaymentTypeFacade) {
      this.userCostCenterService = userCostCenterService;
      this.checkoutCostCenterFacade = checkoutCostCenterFacade;
      this.checkoutPaymentTypeFacade = checkoutPaymentTypeFacade;
      this.subscription = new Subscription();
      this.userCostCenters$ = this.userCostCenterService.getActiveCostCenters().pipe(filter(costCenters => !!costCenters));
    }
    ngOnInit() {
      this.subscription.add(this.checkoutPaymentTypeFacade.isAccountPayment().pipe(distinctUntilChanged()).subscribe(isAccountPayment => {
        this.isAccountPayment = isAccountPayment;
      }));
      this.costCenters$ = combineLatest([this.userCostCenters$, this.checkoutCostCenterFacade.getCostCenterState().pipe(filter(state => !state.loading), map(state => state.data), distinctUntilChanged())]).pipe(take(1), tap(([costCenters, costCenter]) => {
        if (!costCenter) {
          this.setCostCenter(costCenters[0].code);
        } else {
          this.costCenterId = costCenter.code;
        }
      }), map(([costCenters]) => costCenters));
    }
    setCostCenter(selectCostCenter) {
      this.costCenterId = selectCostCenter;
      this.checkoutCostCenterFacade.setCostCenter(this.costCenterId);
    }
    ngOnDestroy() {
      this.subscription.unsubscribe();
    }
    static {
      this.ɵfac = function CheckoutCostCenterComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutCostCenterComponent)(i0.ɵɵdirectiveInject(i1.UserCostCenterService), i0.ɵɵdirectiveInject(i5.CheckoutCostCenterFacade), i0.ɵɵdirectiveInject(i5.CheckoutPaymentTypeFacade));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutCostCenterComponent,
        selectors: [["cx-cost-center"]],
        hostVars: 2,
        hostBindings: function CheckoutCostCenterComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵclassProp("hidden", ctx.disabled);
          }
        },
        standalone: false,
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [1, "row"], [1, "col-md-12", "col-xl-10"], [1, "label-content", "required"], [3, "change"], [3, "value", "selected", 4, "ngFor", "ngForOf"], [1, "label-content"], [3, "value", "selected"]],
        template: function CheckoutCostCenterComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, CheckoutCostCenterComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.isAccountPayment);
          }
        },
        dependencies: [i6.NgForOf, i6.NgIf, i6.AsyncPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutCostCenterComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutCostCenterModule = /*#__PURE__*/(() => {
  class CheckoutCostCenterModule {
    static {
      this.ɵfac = function CheckoutCostCenterModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutCostCenterModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutCostCenterModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, I18nModule, ConfigModule.withConfig({
          cmsComponents: {
            CheckoutCostCenterComponent: {
              component: CheckoutCostCenterComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard]
            }
          }
        })]
      });
    }
  }
  return CheckoutCostCenterModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let B2BCheckoutDeliveryAddressComponent = /*#__PURE__*/(() => {
  class B2BCheckoutDeliveryAddressComponent extends CheckoutDeliveryAddressComponent {
    constructor(userAddressService, checkoutDeliveryAddressFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, checkoutDeliveryModesFacade, globalMessageService, checkoutCostCenterFacade, checkoutPaymentTypeFacade, userCostCenterService) {
      super(userAddressService, checkoutDeliveryAddressFacade, activatedRoute, translationService, activeCartFacade, checkoutStepService, checkoutDeliveryModesFacade, globalMessageService);
      this.userAddressService = userAddressService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.activatedRoute = activatedRoute;
      this.translationService = translationService;
      this.activeCartFacade = activeCartFacade;
      this.checkoutStepService = checkoutStepService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.globalMessageService = globalMessageService;
      this.checkoutCostCenterFacade = checkoutCostCenterFacade;
      this.checkoutPaymentTypeFacade = checkoutPaymentTypeFacade;
      this.userCostCenterService = userCostCenterService;
      this.subscriptions = new Subscription();
      this.isAccountPayment$ = this.checkoutPaymentTypeFacade.isAccountPayment().pipe(distinctUntilChanged());
      this.costCenterAddresses$ = this.checkoutCostCenterFacade.getCostCenterState().pipe(filter(state => !state.loading), map(state => state.data), distinctUntilChanged((prev, curr) => prev?.code === curr?.code), switchMap(costCenter => {
        this.doneAutoSelect = false;
        return costCenter?.code ? this.userCostCenterService.getCostCenterAddresses(costCenter.code) : of([]);
      }));
      this.creditCardAddressLoading$ = super.getAddressLoading();
      this.accountAddressLoading$ = combineLatest([this.creditCardAddressLoading$, this.checkoutCostCenterFacade.getCostCenterState().pipe(map(state => state.loading))]).pipe(map(([creditCardAddressLoading, costCenterLoading]) => creditCardAddressLoading || costCenterLoading), distinctUntilChanged());
      this.isAccountPayment = false;
    }
    ngOnInit() {
      this.subscriptions.add(this.isAccountPayment$.subscribe(isAccount => this.isAccountPayment = isAccount));
      super.ngOnInit();
    }
    loadAddresses() {
      if (!this.isAccountPayment) {
        super.loadAddresses();
      }
      // else: do nothing, as we don't need to load user addresses for account payment
    }
    getAddressLoading() {
      return this.isAccountPayment$.pipe(switchMap(isAccountPayment => isAccountPayment ? this.accountAddressLoading$ : this.creditCardAddressLoading$));
    }
    getSupportedAddresses() {
      return this.isAccountPayment$.pipe(switchMap(isAccountPayment => isAccountPayment ? this.costCenterAddresses$ : super.getSupportedAddresses()));
    }
    selectDefaultAddress(addresses, selected) {
      if (!this.doneAutoSelect && addresses?.length && (!selected || Object.keys(selected).length === 0)) {
        if (this.isAccountPayment) {
          if (addresses.length === 1) {
            this.setAddress(addresses[0]);
          }
        } else {
          super.selectDefaultAddress(addresses, selected);
        }
        this.doneAutoSelect = true;
      }
    }
    ngOnDestroy() {
      this.subscriptions.unsubscribe();
    }
    static {
      this.ɵfac = function B2BCheckoutDeliveryAddressComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || B2BCheckoutDeliveryAddressComponent)(i0.ɵɵdirectiveInject(i1.UserAddressService), i0.ɵɵdirectiveInject(i1$1.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i4.ActiveCartFacade), i0.ɵɵdirectiveInject(i2.CheckoutStepService), i0.ɵɵdirectiveInject(i1$1.CheckoutDeliveryModesFacade), i0.ɵɵdirectiveInject(i1.GlobalMessageService), i0.ɵɵdirectiveInject(i5.CheckoutCostCenterFacade), i0.ɵɵdirectiveInject(i5.CheckoutPaymentTypeFacade), i0.ɵɵdirectiveInject(i1.UserCostCenterService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: B2BCheckoutDeliveryAddressComponent,
        selectors: [["cx-delivery-address"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 7,
        vars: 6,
        consts: [["loading", ""], ["showExistingAddresses", ""], ["newAddressForm", ""], ["initialAddressForm", ""], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [4, "ngIf", "ngIfThen", "ngIfElse"], ["role", "status"], [1, "cx-checkout-text"], ["class", "cx-checkout-btns row", 4, "ngIf"], [1, "cx-checkout-body", "row"], ["class", "cx-delivery-address-card col-md-12 col-lg-6", 4, "ngFor", "ngForOf"], [1, "cx-checkout-btns", "row"], [1, "col-md-12", "col-lg-6"], [1, "cx-btn", "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-btn", "btn", "btn-block", "btn-primary", 3, "click", "disabled"], [1, "col-sm-12", "col-md-12", "col-lg-6"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "cx-delivery-address-card", "col-md-12", "col-lg-6"], [1, "cx-delivery-address-card-inner", 3, "click"], [3, "sendCard", "border", "index", "fitToContainer", "content", "role"], [3, "showTitleCode", "backToAddress", "submitAddress", 4, "ngIf", "ngIfElse"], [3, "backToAddress", "submitAddress", "showTitleCode"], [3, "backToAddress", "submitAddress", "showTitleCode", "setAsDefaultField", "cancelBtnLabel"], [1, "cx-spinner"]],
        template: function B2BCheckoutDeliveryAddressComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 4);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, B2BCheckoutDeliveryAddressComponent_ng_container_3_Template, 3, 4, "ng-container", 5);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵtemplate(5, B2BCheckoutDeliveryAddressComponent_ng_template_5_Template, 2, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "checkoutAddress.shippingAddress"), "\n");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx.cards$));
          }
        },
        dependencies: [i6.NgForOf, i6.NgIf, i8.AddressFormComponent, i7.CardComponent, i7.SpinnerComponent, i1.FeatureDirective, i6.AsyncPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return B2BCheckoutDeliveryAddressComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let B2BCheckoutDeliveryAddressModule = /*#__PURE__*/(() => {
  class B2BCheckoutDeliveryAddressModule {
    static {
      this.ɵfac = function B2BCheckoutDeliveryAddressModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || B2BCheckoutDeliveryAddressModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: B2BCheckoutDeliveryAddressModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutDeliveryAddress: {
              component: B2BCheckoutDeliveryAddressComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard]
            }
          }
        })],
        imports: [CommonModule, RouterModule, AddressFormModule, CardModule, SpinnerModule, I18nModule, FeaturesConfigModule]
      });
    }
  }
  return B2BCheckoutDeliveryAddressModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentTypeComponent = /*#__PURE__*/(() => {
  class CheckoutPaymentTypeComponent {
    constructor(checkoutPaymentTypeFacade, checkoutStepService, activatedRoute, globalMessageService) {
      this.checkoutPaymentTypeFacade = checkoutPaymentTypeFacade;
      this.checkoutStepService = checkoutStepService;
      this.activatedRoute = activatedRoute;
      this.globalMessageService = globalMessageService;
      this.busy$ = new BehaviorSubject(false);
      this.paymentTypesError = false;
      this.isUpdating$ = combineLatest([this.busy$, this.checkoutPaymentTypeFacade.getSelectedPaymentTypeState().pipe(map(state => state.loading))]).pipe(map(([busy, loading]) => busy || loading), distinctUntilChanged());
      this.paymentTypes$ = this.checkoutPaymentTypeFacade.getPaymentTypes().pipe(tap(() => this.paymentTypesError = false), catchError(error => {
        if (error.details?.[0]?.type === "ClassMismatchError" /* OccHttpErrorType.CLASS_MISMATCH_ERROR */) {
          this.globalMessageService.add({
            key: 'httpHandlers.forbidden'
          }, GlobalMessageType.MSG_TYPE_ERROR);
          this.paymentTypesError = true;
        }
        return of([]);
      }));
      this.typeSelected$ = combineLatest([this.checkoutPaymentTypeFacade.getSelectedPaymentTypeState().pipe(filter(state => !state.loading), map(state => state.data)), this.paymentTypes$]).pipe(map(([selectedPaymentType, availablePaymentTypes]) => {
        if (selectedPaymentType && availablePaymentTypes.find(availablePaymentType => {
          return availablePaymentType.code === selectedPaymentType.code;
        })) {
          return selectedPaymentType;
        }
        if (availablePaymentTypes.length) {
          this.busy$.next(true);
          this.checkoutPaymentTypeFacade.setPaymentType(availablePaymentTypes[0].code, this.poNumberInputElement?.nativeElement?.value).subscribe({
            complete: () => this.onSuccess(),
            error: () => this.onError()
          });
          return availablePaymentTypes[0];
        }
        return undefined;
      }), filter(isNotUndefined), distinctUntilChanged(), tap(selected => {
        this.typeSelected = selected?.code;
        this.checkoutStepService.disableEnableStep("paymentDetails" /* CheckoutStepType.PAYMENT_DETAILS */, selected?.code === B2BPaymentTypeEnum.ACCOUNT_PAYMENT);
      }));
      this.cartPoNumber$ = this.checkoutPaymentTypeFacade.getPurchaseOrderNumberState().pipe(filter(state => !state.loading), map(state => state.data), filter(isNotUndefined), distinctUntilChanged());
    }
    changeType(code) {
      this.busy$.next(true);
      this.typeSelected = code;
      this.checkoutPaymentTypeFacade.setPaymentType(code, this.poNumberInputElement.nativeElement.value).subscribe({
        complete: () => this.onSuccess(),
        error: () => this.onError()
      });
    }
    next() {
      if (!this.typeSelected) {
        return;
      }
      const poNumberInput = this.poNumberInputElement.nativeElement.value;
      // if the PO number didn't change
      if (poNumberInput === getLastValueSync(this.cartPoNumber$)) {
        this.checkoutStepService.next(this.activatedRoute);
        return;
      }
      this.busy$.next(true);
      this.checkoutPaymentTypeFacade.setPaymentType(this.typeSelected, poNumberInput).subscribe({
        // we don't call onSuccess here, because it can cause a spinner flickering
        complete: () => this.checkoutStepService.next(this.activatedRoute),
        error: () => this.onError()
      });
    }
    back() {
      this.checkoutStepService.back(this.activatedRoute);
    }
    onSuccess() {
      this.busy$.next(false);
    }
    onError() {
      this.busy$.next(false);
    }
    static {
      this.ɵfac = function CheckoutPaymentTypeComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentTypeComponent)(i0.ɵɵdirectiveInject(i5.CheckoutPaymentTypeFacade), i0.ɵɵdirectiveInject(i2.CheckoutStepService), i0.ɵɵdirectiveInject(i3.ActivatedRoute), i0.ɵɵdirectiveInject(i1.GlobalMessageService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CheckoutPaymentTypeComponent,
        selectors: [["cx-payment-type"]],
        viewQuery: function CheckoutPaymentTypeComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.poNumberInputElement = _t.first);
          }
        },
        standalone: false,
        decls: 7,
        vars: 6,
        consts: [["loading", ""], ["poNumber", ""], [1, "cx-checkout-title", "d-none", "d-lg-block", "d-xl-block"], [4, "ngIf"], [4, "ngIf", "ngIfElse"], ["role", "status", 4, "cxFeature"], [1, "row"], [1, "col-md-12", "col-lg-6"], [1, "label-content"], ["formControlName", "poNumber", "type", "text", 1, "form-control", 3, "placeholder", "value"], [1, "cx-payment-type-container"], ["class", "form-check", 4, "ngFor", "ngForOf"], [1, "cx-checkout-btns", "row"], [1, "btn", "btn-block", "btn-secondary", 3, "click"], [1, "btn", "btn-block", "btn-primary", 3, "click"], ["role", "status"], [1, "form-check"], ["role", "radio", "type", "radio", "aria-checked", "true", "formControlName", "paymentType", 1, "form-check-input", 3, "change", "id", "value", "checked"], [1, "cx-payment-type-label", "form-check-label", "form-radio-label", 3, "for"], [1, "cx-payment-type"], ["class", "cx-spinner", 4, "ngIf"], [1, "cx-spinner"]],
        template: function CheckoutPaymentTypeComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "h2", 2);
            i0.ɵɵtext(1);
            i0.ɵɵpipe(2, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, CheckoutPaymentTypeComponent_ng_container_3_Template, 4, 6, "ng-container", 3);
            i0.ɵɵpipe(4, "async");
            i0.ɵɵtemplate(5, CheckoutPaymentTypeComponent_ng_template_5_Template, 1, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "checkoutB2B.methodOfPayment.paymentType"), "\n");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(4, 4, ctx.paymentTypes$));
          }
        },
        dependencies: [i6.NgForOf, i6.NgIf, i7.SpinnerComponent, i1.FeatureDirective, i6.AsyncPipe, i1.TranslatePipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return CheckoutPaymentTypeComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutPaymentTypeModule = /*#__PURE__*/(() => {
  class CheckoutPaymentTypeModule {
    static {
      this.ɵfac = function CheckoutPaymentTypeModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutPaymentTypeModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutPaymentTypeModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, I18nModule, SpinnerModule, ConfigModule.withConfig({
          cmsComponents: {
            CheckoutPaymentType: {
              component: CheckoutPaymentTypeComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard, CartValidationGuard]
            }
          }
        }), FeaturesConfigModule]
      });
    }
  }
  return CheckoutPaymentTypeModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let B2BCheckoutReviewSubmitComponent = /*#__PURE__*/(() => {
  class B2BCheckoutReviewSubmitComponent extends CheckoutReviewSubmitComponent {
    constructor(checkoutDeliveryAddressFacade, checkoutPaymentFacade, activeCartFacade, translationService, checkoutStepService, checkoutDeliveryModesFacade, checkoutPaymentTypeFacade, checkoutCostCenterFacade, userCostCenterService) {
      super(checkoutDeliveryAddressFacade, checkoutPaymentFacade, activeCartFacade, translationService, checkoutStepService, checkoutDeliveryModesFacade);
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.activeCartFacade = activeCartFacade;
      this.translationService = translationService;
      this.checkoutStepService = checkoutStepService;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.checkoutPaymentTypeFacade = checkoutPaymentTypeFacade;
      this.checkoutCostCenterFacade = checkoutCostCenterFacade;
      this.userCostCenterService = userCostCenterService;
      this.checkoutStepTypePaymentType = "paymentType" /* CheckoutStepType.PAYMENT_TYPE */;
    }
    get poNumber$() {
      return this.checkoutPaymentTypeFacade.getPurchaseOrderNumberState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
    }
    get paymentType$() {
      return this.checkoutPaymentTypeFacade.getSelectedPaymentTypeState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
    }
    get isAccountPayment$() {
      return this.checkoutPaymentTypeFacade.isAccountPayment();
    }
    get costCenter$() {
      return this.checkoutCostCenterFacade.getCostCenterState().pipe(filter(state => !state.loading && !state.error), map(state => state.data));
    }
    getCheckoutPaymentSteps() {
      return ["paymentDetails" /* CheckoutStepType.PAYMENT_DETAILS */, "paymentType" /* CheckoutStepType.PAYMENT_TYPE */, "deliveryAddress" /* CheckoutStepType.DELIVERY_ADDRESS */];
    }
    getCostCenterCard(costCenter) {
      return combineLatest([this.translationService.translate('checkoutB2B.costCenter')]).pipe(map(([textTitle]) => {
        return {
          title: textTitle,
          textBold: costCenter?.name,
          text: ['(' + costCenter?.unit?.name + ')']
        };
      }));
    }
    getPoNumberCard(poNumber) {
      return combineLatest([this.translationService.translate('checkoutB2B.review.poNumber'), this.translationService.translate('checkoutB2B.noPoNumber')]).pipe(map(([textTitle, noneTextTitle]) => {
        return {
          title: textTitle,
          textBold: poNumber ? poNumber : noneTextTitle
        };
      }));
    }
    getPaymentTypeCard(paymentType) {
      return combineLatest([this.translationService.translate('checkoutB2B.progress.methodOfPayment'), this.translationService.translate('paymentTypes.paymentType_' + paymentType.code)]).pipe(map(([textTitle, paymentTypeTranslation]) => {
        return {
          title: textTitle,
          textBold: paymentTypeTranslation
        };
      }));
    }
    static {
      this.ɵfac = function B2BCheckoutReviewSubmitComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || B2BCheckoutReviewSubmitComponent)(i0.ɵɵdirectiveInject(i1$1.CheckoutDeliveryAddressFacade), i0.ɵɵdirectiveInject(i1$1.CheckoutPaymentFacade), i0.ɵɵdirectiveInject(i4.ActiveCartFacade), i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i2.CheckoutStepService), i0.ɵɵdirectiveInject(i1$1.CheckoutDeliveryModesFacade), i0.ɵɵdirectiveInject(i5.CheckoutPaymentTypeFacade), i0.ɵɵdirectiveInject(i5.CheckoutCostCenterFacade), i0.ɵɵdirectiveInject(i1.UserCostCenterService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: B2BCheckoutReviewSubmitComponent,
        selectors: [["cx-review-submit"]],
        standalone: false,
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 21,
        vars: 9,
        consts: [["poNumber", ""], ["paymentType", ""], ["costCenter", ""], ["deliveryAddress", ""], ["deliveryMode", ""], ["paymentMethod", ""], [1, "cx-review"], [1, "cx-review-title", "d-none", "d-lg-block", "d-xl-block"], [1, "cx-review-summary", "row"], [4, "ngIf"], [1, "col-md-12", "col-lg-6", "col-xl-6", "cx-review-payment-col"], [4, "ngFor", "ngForOf"], [1, "col-md-12", "col-lg-6", "col-xl-6", "cx-review-shipping-col"], [3, "ngSwitch"], [4, "ngSwitchCase"], [4, "ngTemplateOutlet"], [1, "cx-review-summary-card"], [3, "content"], [1, "cx-review-summary-edit-step"], [3, "routerLink"], ["aria-hidden", "true", 3, "type"], [3, "content", 4, "ngIf"], ["class", "cx-review-summary-card cx-review-card-address", 4, "ngIf"], [1, "cx-review-summary-card", "cx-review-card-address"], [1, "cx-review-summary-card", "cx-review-card-shipping"], [3, "cxOutlet", "cxOutletContext"], [1, "cx-review-summary-card", "cx-review-card-payment"], [1, "cx-review-cart-total", "d-none", "d-lg-block", "d-xl-block"], [1, "cx-review-cart-heading", "d-block", "d-lg-none", "d-xl-none"], ["class", "cx-review-cart-item", 4, "ngIf"], [1, "cx-review-cart-item"], [3, "promotions"]],
        template: function B2BCheckoutReviewSubmitComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 6)(1, "h2", 7);
            i0.ɵɵtext(2);
            i0.ɵɵpipe(3, "cxTranslate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(4, "div", 8);
            i0.ɵɵtemplate(5, B2BCheckoutReviewSubmitComponent_ng_container_5_Template, 5, 2, "ng-container", 9);
            i0.ɵɵpipe(6, "async");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(7, B2BCheckoutReviewSubmitComponent_ng_template_7_Template, 9, 14, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(9, B2BCheckoutReviewSubmitComponent_ng_template_9_Template, 8, 12, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(11, B2BCheckoutReviewSubmitComponent_ng_template_11_Template, 2, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor)(13, B2BCheckoutReviewSubmitComponent_ng_template_13_Template, 2, 3, "ng-template", null, 3, i0.ɵɵtemplateRefExtractor)(15, B2BCheckoutReviewSubmitComponent_ng_template_15_Template, 11, 18, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor)(17, B2BCheckoutReviewSubmitComponent_ng_template_17_Template, 9, 12, "ng-template", null, 5, i0.ɵɵtemplateRefExtractor)(19, B2BCheckoutReviewSubmitComponent_ng_container_19_Template, 9, 13, "ng-container", 9);
            i0.ɵɵpipe(20, "async");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_7_0;
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, "checkoutReview.review"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", (tmp_7_0 = i0.ɵɵpipeBind1(6, 5, ctx.steps$)) == null ? null : tmp_7_0.slice(0, -1));
            i0.ɵɵadvance(14);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(20, 7, ctx.cart$));
          }
        },
        dependencies: [i6.NgForOf, i6.NgIf, i6.NgTemplateOutlet, i6.NgSwitch, i6.NgSwitchCase, i7.CardComponent, i3.RouterLink, i7.PromotionsComponent, i7.IconComponent, i7.OutletDirective, i6.AsyncPipe, i1.TranslatePipe, i1.UrlPipe],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return B2BCheckoutReviewSubmitComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let B2BCheckoutReviewSubmitModule = /*#__PURE__*/(() => {
  class B2BCheckoutReviewSubmitModule {
    static {
      this.ɵfac = function B2BCheckoutReviewSubmitModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || B2BCheckoutReviewSubmitModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: B2BCheckoutReviewSubmitModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [provideDefaultConfig({
          cmsComponents: {
            CheckoutReviewOrder: {
              component: B2BCheckoutReviewSubmitComponent,
              guards: [CheckoutAuthGuard, CartNotEmptyGuard]
            }
          }
        })],
        imports: [CommonModule, CardModule, I18nModule, UrlModule, RouterModule, PromotionsModule, IconModule, OutletModule]
      });
    }
  }
  return B2BCheckoutReviewSubmitModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutB2BAuthGuard = /*#__PURE__*/(() => {
  class CheckoutB2BAuthGuard extends CheckoutAuthGuard {
    constructor(authService, authRedirectService, checkoutConfigService, activeCartFacade, semanticPathService, router, userAccountFacade, globalMessageService) {
      super(authService, authRedirectService, checkoutConfigService, activeCartFacade, semanticPathService, router);
      this.authService = authService;
      this.authRedirectService = authRedirectService;
      this.checkoutConfigService = checkoutConfigService;
      this.activeCartFacade = activeCartFacade;
      this.semanticPathService = semanticPathService;
      this.router = router;
      this.userAccountFacade = userAccountFacade;
      this.globalMessageService = globalMessageService;
    }
    canActivate() {
      return combineLatest([this.authService.isUserLoggedIn(), this.activeCartFacade.isGuestCart(), this.userAccountFacade.get(), this.activeCartFacade.isStable()]).pipe(map(([isLoggedIn, isGuestCart, user, isStable]) => ({
        isLoggedIn,
        isGuestCart,
        user,
        isStable
      })), filter(data => data.isStable),
      // if the user is authenticated and we have their data, OR if the user is anonymous
      filter(data => !!data.user && data.isLoggedIn || !data.isLoggedIn), map(data => {
        if (!data.isLoggedIn) {
          return data.isGuestCart ? true : this.handleAnonymousUser();
        } else if (data.user && 'roles' in data.user) {
          return this.handleUserRole(data.user);
        }
        return data.isLoggedIn;
      }));
    }
    handleUserRole(user) {
      const roles = user.roles;
      if (roles?.includes(B2BUserRole.CUSTOMER)) {
        return true;
      }
      this.globalMessageService.add({
        key: 'checkoutB2B.invalid.accountType'
      }, GlobalMessageType.MSG_TYPE_WARNING);
      return this.router.parseUrl(this.semanticPathService.get('home') ?? '');
    }
    static {
      this.ɵfac = function CheckoutB2BAuthGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutB2BAuthGuard)(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i1.AuthRedirectService), i0.ɵɵinject(i2.CheckoutConfigService), i0.ɵɵinject(i4.ActiveCartFacade), i0.ɵɵinject(i1.SemanticPathService), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i5$1.UserAccountFacade), i0.ɵɵinject(i1.GlobalMessageService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutB2BAuthGuard,
        factory: CheckoutB2BAuthGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutB2BAuthGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutB2BStepsSetGuard = /*#__PURE__*/(() => {
  class CheckoutB2BStepsSetGuard extends CheckoutStepsSetGuard {
    constructor(checkoutStepService, routingConfigService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, checkoutDeliveryModesFacade, router, checkoutPaymentTypeFacade, checkoutCostCenterFacade, activeCartFacade) {
      super(checkoutStepService, routingConfigService, checkoutDeliveryAddressFacade, checkoutPaymentFacade, checkoutDeliveryModesFacade, router, activeCartFacade);
      this.checkoutStepService = checkoutStepService;
      this.routingConfigService = routingConfigService;
      this.checkoutDeliveryAddressFacade = checkoutDeliveryAddressFacade;
      this.checkoutPaymentFacade = checkoutPaymentFacade;
      this.checkoutDeliveryModesFacade = checkoutDeliveryModesFacade;
      this.router = router;
      this.checkoutPaymentTypeFacade = checkoutPaymentTypeFacade;
      this.checkoutCostCenterFacade = checkoutCostCenterFacade;
      this.activeCartFacade = activeCartFacade;
      this.logger = inject(LoggerService);
    }
    canActivate(route) {
      let currentIndex = -1;
      const currentRouteUrl = '/' + route.url.join('/');
      // check whether the previous step is set
      return combineLatest([this.checkoutStepService.steps$, this.checkoutPaymentTypeFacade.isAccountPayment()]).pipe(tap(([, isAccount]) => {
        this.checkoutStepService.disableEnableStep("paymentDetails" /* CheckoutStepType.PAYMENT_DETAILS */, isAccount);
      }), take(1), switchMap(([steps, isAccount]) => {
        currentIndex = steps.findIndex(step => {
          const stepRouteUrl = `/${this.routingConfigService.getRouteConfig(step.routeName)?.paths?.[0]}`;
          return stepRouteUrl === currentRouteUrl;
        });
        // get current step
        let currentStep;
        if (currentIndex >= 0) {
          currentStep = steps[currentIndex];
        }
        if (Boolean(currentStep)) {
          return this.isB2BStepSet(steps[currentIndex - 1], isAccount);
        } else {
          if (isDevMode()) {
            this.logger.warn(`Missing step with route '${currentRouteUrl}' in checkout configuration or this step is disabled.`);
          }
          return of(this.getUrl('checkout'));
        }
      }));
    }
    isB2BStepSet(step, isAccountPayment) {
      if (step && !step.disabled) {
        switch (step.type[0]) {
          case "paymentType" /* CheckoutStepType.PAYMENT_TYPE */:
            {
              return this.isPaymentTypeSet(step);
            }
          case "deliveryAddress" /* CheckoutStepType.DELIVERY_ADDRESS */:
            {
              return this.isDeliveryAddressAndCostCenterSet(step, isAccountPayment);
            }
          case "deliveryMode" /* CheckoutStepType.DELIVERY_MODE */:
            {
              return this.isDeliveryModeSet(step);
            }
          case "paymentDetails" /* CheckoutStepType.PAYMENT_DETAILS */:
            {
              return this.isPaymentDetailsSet(step);
            }
          case "reviewOrder" /* CheckoutStepType.REVIEW_ORDER */:
            {
              break;
            }
        }
      }
      return of(true);
    }
    isPaymentTypeSet(step) {
      return this.checkoutPaymentTypeFacade.getSelectedPaymentTypeState().pipe(filter(state => !state.loading), map(state => state.data), map(paymentType => {
        if (paymentType) {
          return true;
        } else {
          return this.getUrl(step.routeName);
        }
      }));
    }
    isDeliveryAddressAndCostCenterSet(step, isAccountPayment) {
      return combineLatest([this.checkoutDeliveryAddressFacade.getDeliveryAddressState().pipe(filter(state => !state.loading), map(state => state.data)), this.checkoutCostCenterFacade.getCostCenterState().pipe(filter(state => !state.loading), map(state => state.data))]).pipe(map(([deliveryAddress, costCenter]) => {
        if (isAccountPayment) {
          if (deliveryAddress && Object.keys(deliveryAddress).length && !!costCenter) {
            return true;
          } else {
            return this.getUrl(step.routeName);
          }
        } else {
          if (deliveryAddress && Object.keys(deliveryAddress).length && costCenter === undefined) {
            return true;
          } else {
            return this.getUrl(step.routeName);
          }
        }
      }));
    }
    static {
      this.ɵfac = function CheckoutB2BStepsSetGuard_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutB2BStepsSetGuard)(i0.ɵɵinject(i2.CheckoutStepService), i0.ɵɵinject(i1.RoutingConfigService), i0.ɵɵinject(i1$1.CheckoutDeliveryAddressFacade), i0.ɵɵinject(i1$1.CheckoutPaymentFacade), i0.ɵɵinject(i1$1.CheckoutDeliveryModesFacade), i0.ɵɵinject(i3.Router), i0.ɵɵinject(i5.CheckoutPaymentTypeFacade), i0.ɵɵinject(i5.CheckoutCostCenterFacade), i0.ɵɵinject(i4.ActiveCartFacade));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CheckoutB2BStepsSetGuard,
        factory: CheckoutB2BStepsSetGuard.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CheckoutB2BStepsSetGuard;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */
let CheckoutB2BComponentsModule = /*#__PURE__*/(() => {
  class CheckoutB2BComponentsModule {
    static {
      this.ɵfac = function CheckoutB2BComponentsModule_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || CheckoutB2BComponentsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CheckoutB2BComponentsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [{
          provide: CheckoutAuthGuard,
          useExisting: CheckoutB2BAuthGuard
        }, {
          provide: CheckoutStepsSetGuard,
          useExisting: CheckoutB2BStepsSetGuard
        }],
        imports: [CommonModule, CheckoutCostCenterModule, CheckoutPaymentTypeModule, B2BCheckoutDeliveryAddressModule, B2BCheckoutReviewSubmitModule]
      });
    }
  }
  return CheckoutB2BComponentsModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generated bundle index. Do not edit.
 */

export { B2BCheckoutDeliveryAddressComponent, B2BCheckoutDeliveryAddressModule, B2BCheckoutReviewSubmitComponent, B2BCheckoutReviewSubmitModule, CheckoutB2BAuthGuard, CheckoutB2BComponentsModule, CheckoutB2BStepsSetGuard, CheckoutCostCenterComponent, CheckoutCostCenterModule, CheckoutPaymentTypeComponent, CheckoutPaymentTypeModule };
